import React, { useState } from 'react';
import ButtonsGeneric from '../../../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../../../components/NovoSistema/ContainerSection';
import DoubleInput from '../../../../../../../../components/NovoSistema/DoubleInput';
import InputDate from '../../../../../../../../components/NovoSistema/InputDate';
import InputCheckBox from '../../../../../../../../components/NovoSistema/InputCheckBox';
import { WrapperInputsNewSystem } from '../../../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import ButtonOptions from '../../../../../../../../components/NovoSistema/ButtonOptions';
import HeaderButtons from '../../../../../../../../components/NovoSistema/HeaderButtons';
import InputText from '../../../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../../../components/NovoSistema/SelectAndOptions';

export default function MovimentacaoFilter() {
  const [option, setOption] = useState('Filtro');
  return (
    <div>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Filtro"
          border="#DFB007"
          active={option === 'Filtro' ? true : false}
          yourFunction={() => setOption('Filtro')}
        />
      </HeaderButtons>
      {option === 'Filtro' && (
        <ContainerSection>
          <WrapperInputsNewSystem>
            <InputDate title="Período Inicial" id="PeriodoInicial" widthPercentage="20%" />
            <InputDate title="Período Final" id="PeriodoFinal" widthPercentage="20%" />
            <SelectAndOptions
              title="Tipo de documento"
              id="TipoDeDocumento"
              optionsArray={[
                '',
                '1  | NF    | Nota Fiscal',
                '1B | NFA   | Nota Fiscal Avulsa',
                '2  | NFVC  | Nota Fiscal Venda Consumidor',
                '2D | CFECF | Cupom Fiscal - ECF',
                '4  | NFP   | Nota Fiscal Produtor',
                '55 | NFE   | Nota Fiscal Eletrônica',
                '59 | CFE   | Cupom Fiscal Eletrônico - SAT',
                '65 | NFCE  | Nota Fiscal Eletrônica ao Consumidor Final - NFC-e',
                '99 | INT   | Outros - Uso Interno',
              ]}
              widthPercentage="40%"
            />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <DoubleInput title="Produto" id="Produto" widthPercentage="40%" />
            <SelectAndOptions
              title="Tipo de Mov."
              id="TipoDeMovimentacao"
              optionsArray={[
                'Todas',
                'Ajuste de Entrada',
                'Ajuste de Saída',
                'Cancelamento de Entrada',
                'Cancelamentos de Saída',
                'Devolução Entrada',
                'Devolução Saída',
                'Movimentação de Entrada',
                'Movimentação de Saída',
                'Requisição de Material',
                'Retorno',
                'Saldo Inicial',
                'Transferência Entrada',
                'Transferência Saída',
              ]}
              widthPercentage="20%"
            />
            <SelectAndOptions
              title="Origem"
              id="Origem"
              optionsArray={['Todos', 'Estoque', 'Faturamento', 'PDV', 'Produção']}
              widthPercentage="20%"
            />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Emitido para"
              id="EmitidoPara"
              optionsArray={['', 'Matriz/Final', 'Terceiros']}
              widthPercentage="20%"
            />
            <DoubleInput title="Parceiro de Negócios" id="ParceiroDeNegocios" widthPercentage="40%" disabled={true} />
            <InputText title="Nro do Documento" id="NroDoDocumento" widthPercentage="20%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Quebrado por"
              id="QuebradoPor"
              optionsArray={['', 'Produto', 'Localização', 'Parceiro de Negócios', 'Origem da Operação']}
              widthPercentage="20%"
            />
            <SelectAndOptions
              title="Tipo de Pessoa"
              id="TipoDePessoa"
              optionsArray={['Todas', 'Física', 'Jurídica']}
              widthPercentage="20%"
            />
            <InputText title="CNPJ/CPF" id="CNPJCPF" widthPercentage="20%" disabled={true} />
            <InputCheckBox title="Canceladas" id="Canceladas" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <DoubleInput title="Localização Inicial" id="LocalizacaoInicial" widthPercentage="40%" />
            <DoubleInput title="Localização Final" id="LocalizacaoFinal" widthPercentage="40%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Divisão Gerencial"
              id="DivisaoGerencial"
              optionsArray={['', 'Grupo', 'Marca', 'Fabricante', 'Familia', 'SubTipo', 'Linha', 'Departamento']}
              widthPercentage="20%"
            />
            <DoubleInput title="Inicial" id="Inicial" widthPercentage="30%" disabled={true} />
            <DoubleInput title="Final" id="Final" widthPercentage="30%" disabled={true} />
          </WrapperInputsNewSystem>
          <ButtonsGeneric>
            <button className="normal">Limpar</button>
          </ButtonsGeneric>
        </ContainerSection>
      )}
    </div>
  );
}
